import moment from "moment";

export function formatDate(date, showTime = false, noTimezone = false) {
  if (!moment(date).isValid()) return "";
  let formattedDate = moment(date);
  if (noTimezone) {
    formattedDate = formattedDate.utc();
  }
  return formattedDate.format("Do MMM YYYY" + (showTime ? " - hh:mm A" : ""));
}
